import { Component, OnInit } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { CommonDashboardService } from '../../../../services/common-dashboard.service';
import { ShortNumberPipe } from '../../../../pipes/short-number.pipe';
import { AssetVersionPipe } from '../../../../pipes/asset-version.pipe';
import { StateService } from '../../../../services/state.service';


@Component({
  selector: 'app-top-level-metrics',
  imports: [NgIf, NgFor, ShortNumberPipe, NgClass, AssetVersionPipe],
  templateUrl: './top-level-metrics.component.html',
  styleUrl: './top-level-metrics.component.scss'
})
export class TopLevelMetricsComponent implements OnInit {
  constructor(private dashboardService: CommonDashboardService, private stateService: StateService) {
  }
  metrics: { name: string, value: number }[] = [];
  ngOnInit() {
    this.stateService.loading = true;
    this.dashboardService.getTopLevelMetrics().subscribe(response => {
      this.metrics = response.items;
    })
    this.stateService.loading = false;
  }

}
